/* eslint-disable global-require */
import React, { Suspense } from 'react'
import { Route, Routes, Navigate, useLocation, useParams, useNavigate } from 'react-router'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'
import { getConfig } from 'env'

import ReactShortcut from 'react-shortcut'

import { history as globalHistory } from 'index'

import { notifyMouseMove, deleteUMKFromLocal } from 'pUtils'
import { checkSearchParams, lockSafebox } from 'utils'
import { isKR } from 'conf'
import store from 'store'

import Layout from 'layouts'

export function withRouter(Component, options) {
  return (props) => {
    const newProps = {
      ...props,
    }

    newProps.location = useLocation()
    newProps.navigate = useNavigate()
    newProps.history = globalHistory
    newProps.match = {
      params: useParams(),
      path: newProps.location.pathname,
    }

    if (options != null && options.navigate === true) {
      newProps.navigate = useNavigate()
    }

    return <Component {...newProps} />
  }
}

const mapStateToProps = ({ menu, settings }) => ({
  myRoutes: menu.routerData,
  routerAnimation: settings.routerAnimation,
})

@connect(mapStateToProps)
class Router extends React.Component {
  cssRef = React.createRef()

  constructor(props) {
    super(props)
    const { history } = props
    this.unsubscribeFromHistory = history.listen(this.handleLocationChange)
    this.handleLocationChange(history.location)

    document.addEventListener('mousemove', this.onMouseMove)
  }

  componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory()
    document.removeEventListener('mousemove', this.onMouseMove)
  }

  onMouseMove = () => {
    notifyMouseMove()
  }

  handleLocationChange = (e) => {
    const { history } = this.props
    console.log('ROUTE CHANGED', e, history)

    if ((e.pathname === '' || e.pathname === '/') && e.key === 'default') {
      deleteUMKFromLocal()
    }

    checkSearchParams()
  }

  render = () => {
    const { routerAnimation, myRoutes, location } = this.props
    const defaultPage = getConfig('defaultPage')
    const isMac = navigator.platform.toUpperCase().includes('MAC')

    const modifierKey = isMac ? 'command' : 'ctrl'

    return (
      <Layout>
        <ReactShortcut
          keys={`${modifierKey}+Shift+L`}
          onKeysPressed={() => {
            console.log('command+shift+l')
            lockSafebox()
          }}
        />
        <SwitchTransition>
          <CSSTransition
            key={location.pathname}
            appear
            nodeRef={this.cssRef}
            classNames={routerAnimation}
            timeout={routerAnimation === 'none' ? 0 : 300}
          >
            <Routes location={location}>
              <Route exact path="/" element={
                isKR() && !store.get('app.user.token')
                  ? <Navigate to="/auth/sso-auth" />
                  : <Navigate to={defaultPage} />
              } />
              {myRoutes.map(({ path, Component }) => {
                return (
                  <Route
                    path={path}
                    key={path}
                    element={
                      <Suspense>
                        <div className={routerAnimation}>
                          <Component />
                        </div>
                      </Suspense>
                    }
                  />
                )
              })}
              <Route path="/invite/*" element={null} />
              <Route exact path="*" element={<Navigate to={defaultPage} />} />
            </Routes>
          </CSSTransition>
        </SwitchTransition>
      </Layout>
    )
  }
}

export default connect(mapStateToProps)(withRouter(Router))
